import { gql } from "@apollo/client";

export const GET_ALL_EQUIPMENT_FOR_SELECT_FIELD = gql`
    query allEquipment {
        allEquipment {
            id
            name
            sku
            itemWeightInLbs
            category {
                name
            }
        }
    }
`